export const ACCOUNT_REFETCH_DELAY_MS = 2000;
